<template>
  <div class="container-fluid mt-2">
    <h2>Benutzer</h2>
    <b-tabs content-class="mt-3">
      <b-tab title="Benuzter">
        <UserEntry @update="updateUser" :user="user"/>
      </b-tab>
      <b-tab title="Anmeldung">
        <UserLogin :userid="userid" ref="login" @loaded="loadTasks"/>
      </b-tab>
      <b-tab title="Aufgaben">
        <UserTaskEditor ref="tasks" :userid="userid"/>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import UserEntry from '@/components/admin/UserEntry.vue'
import UserLogin from '@/components/admin/UserLogin.vue'
import UserTaskEditor from '@/components/admin/UserTaskEditor.vue'
import sysuser from '@/modules/sysuser.js'

export default {
  name: 'UserEditor',
  components: {
    UserEntry,
    UserLogin,
    UserTaskEditor
  },
  data() {
    return {
      userid: -1,
      user: {},
      role: ''
    }
  },
  created: function() {
    this.userid = this.$route.params.userid;
    if (this.userid == 'new') {
      this.userid = 0;
    } else {
      this.fetchData();
    }
    console.log(this.userid);
  },
  methods: {
    loadTasks: function() {
      console.log('loaded: ' + this.$refs.login.login.login);
      this.role = this.$refs.login.login.login;
      this.$refs.tasks.fetchData(this.role);
    },
    updateUser: function(data) {
      console.log('update user');
      this.userid = data.id;
      this.user = data;
    },
    fetchData: function() {
      console.log('load user');
      var self = this;
      sysuser.load(this.userid,function(data) {
        self.user = data;
      })
    }
  }
}
</script>
